/* MirthWell site scripts. Moved out of snippets/mw-custom.liquid on 2026-10-01 (theme code cleanup step 3,
   docs/code-health/). Loaded with defer on every page, so it runs once the HTML is parsed and the browser caches it.
   Each part checks the page type itself and does nothing elsewhere. */
/* ---- header (every page) ---- */
/* MirthWell header: measure the fixed announcement bar so the sticky header sits under it,
   and mark the nav item matching the current URL. Defensive throughout — a header change
   must never throw and break other scripts on the page. */
(function () {
  function annHeight() {
    try {
      var a = document.querySelector('.announcement-bar');
      if (!a) return 0;
      var cs = getComputedStyle(a);
      if (cs.position !== 'fixed' || cs.display === 'none') return 0;
      return Math.round(a.getBoundingClientRect().height);
    } catch (e) { return 0; }
  }
  function setOffset() {
    try { document.documentElement.style.setProperty('--mw-annh', annHeight() + 'px'); } catch (e) {}
  }
  function markCurrent() {
    try {
      var path = window.location.pathname.replace(/\/+$/, '');
      if (!path) return;
      var items = document.querySelectorAll('.site-nav__item');
      for (var i = 0; i < items.length; i++) {
        var li = items[i];
        var links = li.querySelectorAll('a[href]');
        var hit = false;
        for (var j = 0; j < links.length; j++) {
          var href = links[j].getAttribute('href') || '';
          if (href.charAt(0) !== '/') continue;
          if (href.replace(/\/+$/, '') === path) {
            hit = true;
            if (links[j].classList.contains('site-nav__dropdown-link')) {
              links[j].classList.add('mw-nav-current');
            }
          }
        }
        if (hit) li.classList.add('mw-nav-current');
      }
    } catch (e) {}
  }
  function onScroll() {
    try {
      var h = document.querySelector('.site-header');
      if (h) h.classList.toggle('mw-stuck', window.scrollY > 6);
    } catch (e) {}
  }
  function init() { setOffset(); markCurrent(); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('resize', setOffset, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ---- header (every page): the menu never wraps ---- */
/* Owner 2026-10-03: "make sure it never goes into two lines". The CSS in mw-custom keeps the desktop menu on one row;
   if the row ever needs more room than its box (a new or longer menu item, unusual fonts or zoom), html.mw-nav-tight
   swaps it for the menu button + drawer, as on tablets. Re-checked on resize and once the web fonts have loaded. */
(function () {
  var box = document.querySelector('.header-item--navigation');
  var list = box && box.querySelector('.site-navigation');
  if (!list) return;
  var root = document.documentElement, queued = 0;
  function fit() {
    queued = 0;
    try {
      root.classList.remove('mw-nav-tight');
      if (list.offsetWidth && list.scrollWidth > box.clientWidth - 8) root.classList.add('mw-nav-tight');
    } catch (e) {}
  }
  function later() { if (!queued) queued = window.requestAnimationFrame(fit); }
  fit();
  window.addEventListener('resize', later, { passive: true });
  try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(later); } catch (e) {}
})();

/* ---- article: writer avatars (2026-10-15) ---- */
/* Puts the owner-approved drawn avatar into the byline and author-box circles of a post. The circle keeps its
   initials underneath, so a writer without an avatar keeps the old look. Styles: snippets/mw-custom.liquid. */
(function () {
  var KNOWN = ['sarah-g', 'lily-r', 'jake-s', 'danny-r', 'tonny-g'];
  function run() {
    try {
      if (!document.body.classList.contains('template-article')) return;
      [['.mw-byline', '.mw-byline__who', '.mw-byline__mono'], ['.mw-author', '.mw-author__name', '.mw-author__mono']].forEach(function (s) {
        var boxes = document.querySelectorAll(s[0]);
        for (var i = 0; i < boxes.length; i++) {
          var who = boxes[i].querySelector(s[1]), mono = boxes[i].querySelector(s[2]);
          if (!who || !mono) continue;
          var slug = (who.textContent || '').toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');
          if (KNOWN.indexOf(slug) > -1) mono.className += ' mw-av mw-av--' + slug;
        }
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ---- article: toy cards (owner-approved 2026-10-15) ---- */
/* A card under the part of a post that talks about a toy. Only toys the post already links to get a card (so the
   blog's age and safety gates still decide), at most 4 per post, in the order the post first mentions them. Links
   inside the "At a glance" table, the Read next line, the sources, the author box and the guide cards are ignored.
   A toy named in a heading gets its card after the first paragraph of that section (sections can hold a figure of
   the NEXT toy, so never the section end); a toy linked in a sentence gets it right after that paragraph or list.
   Data comes from /products/<handle>.js only when the reader scrolls within ~800px; an unavailable or archived toy
   drops its card. A click sends the GA4 event blog_toy_card_click (param design: v1 / v2).
   TWO DESIGNS:
   - v1 (default): small box, photo + name + age + today's price. Fixed 114px height.
   - v2 (owner 2026-10-15, "catch the eye"; on ALL posts since 2026-10-16 (owner)): bold colour band, the toy as
     a die-cut sticker (a clean cut-out in the theme assets, or the product photo as a tilted sticker photo when the
     cut-out is not clean), a hook headline (no price), a hand-written note pointing at one true detail, a 0-5 age
     ruler from the age tags, a "Teacher-picked" badge, the free-shipping line, and a one-time entrance (< 5 s of
     motion; none with reduced motion). Hooks and notes are per-toy text from the listing's facts (owner sees them).
   Styles: snippets/mw-custom.liquid (.mw-toycard = v1, .mw-tc = v2). */
(function () {
  var MAX = 4;
  var SKIP = 'table, .mw-readnext, .mw-sources, .mw-author, .mw-byline, .mw-guide-card, .mw-toycards';
  // Owner-approved hook + note per toy (2026-10-16, two batches, https://claude.ai/artifact/YJRDrdc6c9Q8jmzSSQFLY2);
  // source of truth: scratchpad/blog-toycards/hooks.json. A toy without an entry shows its NAME as the headline.
  var V2 = {
    toys: {
      'wooden-hand-grab-peg-puzzle-boards-montessori': { hook: 'A knob on every piece, made for a small pinch', note: 'pick from 11 themes!' },
      'montessori-busy-book-match-and-stick-quiet-learning': { hook: 'Find the card that belongs in each spot, page after page', note: 'the cards peel off and stick again!' },
      'wooden-alphabet-number-shape-matching-board-montessori': { hook: 'Letters and numbers your child can actually hold', note: 'solid beech wood!', cut: 'mw-cut-alphabet-board.webp', w: 600, h: 591 },
      'wooden-fruit-lacing-threading-toy-montessori': { hook: 'Little fingers learn to sew, one apple hole at a time', note: 'the worm is the needle!', cut: 'mw-cut-fruit-lacing.webp', w: 584, h: 600 },
      'felt-farm-story-board-montessori': { hook: 'A brand-new farm story, every single time', note: 'nothing is glued down!' },
      'wooden-shape-sorter-box': { hook: '15 shapes to post, from cube to flower', note: 'yes, a flower shape!' },
      'kids-cleaning-toy-set-broom-mop-dustpan-montessori': { hook: 'A real broom and mop, sized for small hands', note: 'the rack keeps it all tidy!' },
      'wooden-color-matching-slide-logic-puzzle-montessori': { hook: 'Slide the discs to crack the color code', note: 'a new puzzle every row!' },
      'wooden-montessori-drawer-box-shape-sorting': { hook: 'Post it in, open the drawer, find it again', note: 'a real pull-out drawer!' },
      'standing-wooden-abacus-100-beads-number-tiles': { hook: 'A hundred beads make math you can touch', note: 'real + and − tiles!' },
      'wooden-rainbow-bead-pegboard': { hook: 'Spoon, clip and sort a rainbow of beads', note: 'chopsticks included!' },
      'montessori-kids-cooking-tools-set-real-knives-cutting-board': { hook: 'Real cooking tools, made kid-safe', note: 'a beechwood crocodile knife!' },
      'montessori-wooden-peg-people-board': { hook: 'Nine peg people, each with one right home', note: 'no two are the same size!' },
      'wooden-color-memory-game': { hook: 'Roll the die, remember where the colors hide', note: 'for ages 3 to grown-up!' },
      'wooden-stick-drop-tower-game-montessori': { hook: 'Pull a stick, hold your breath, hear the drop', note: 'you can see inside!' },
      'wooden-math-fishing-board': { hook: 'Catch a fish, read its number, count it in', note: 'the rod is magnetic!' },
      'magnetic-wooden-animal-train-montessori': { hook: 'Ten animals board a train that clicks together', note: 'magnets do the coupling!' },
      'wooden-double-sided-standing-easel-kids-chalkboard-whiteboard': { hook: 'Chalk on one side, markers on the other', note: 'it grows with your child!' },
      'wooden-magnetic-bead-maze-colors-counting': { hook: 'A magnet pen walks every bead home', note: 'beads sealed in, zero mess!' },
      'montessori-felt-story-board-set': { hook: 'A wall-size felt world your child rearranges', note: 'over a meter wide!' },
      'wooden-shape-color-puzzle-board': { hook: 'Lift by the knob, find where it fits', note: 'knobs built for a pinch!' },
      'balance-stepping-stones-5-piece-rainbow': { hook: 'The floor becomes a path to cross', note: 'non-slip top and feet!' },
      'rock-climbing-wall-holds-10-piece-set-for-kids': { hook: 'Turn one wall into their first climb', note: 'holds only, you add the wall!' },
      'wooden-tea-kitchen-play-set-montessori': { hook: 'A tea party in nine pieces of beech', note: 'its own travel pouch!' },
      'wooden-play-kitchen-cookware-dining-set': { hook: 'Cook, serve and set the table for two', note: 'plates, forks and all!' },
      'wooden-color-matching-stick-canister-montessori': { hook: 'Post every stick through its own ring', note: 'the lid snaps on by magnet!' },
      'wooden-screwdriver-bolt-board-montessori': { hook: 'Eight real bolts and three tools to master', note: 'a real wing nut!' },
      'montessori-sensory-busy-ball-10-in-1-activity-toy': { hook: 'Ten little jobs hiding in one ball', note: 'even a pull-string gopher!' },
      'wooden-5in1-activity-cube': { hook: 'Five toys stacked into one wooden cube', note: 'no batteries, ever!' },
      'wooden-baby-xylophone-montessori-musical-instrument': { hook: 'First notes on real tuned bars', note: 'eight real notes!' },
      'wooden-rainmaker-rain-stick-sensory-toy-montessori': { hook: 'Turn it over and it rains indoors', note: 'beads sealed inside!' },
      'montessori-magic-tissue-box-baby-sensory-cube': { hook: 'The tissue box they are finally allowed to empty', note: 'scarves go back in!' },
      'wooden-baby-musical-instrument-set-montessori': { hook: 'A five-piece band for six months and up', note: 'shake, roll, clap, toot!' },
      'silicone-rainbow-stacker-arches-peg-dolls-montessori': { hook: 'A squishy rainbow with six little riders', note: 'soft, quiet, stackable!' },
      'wooden-color-sorting-cups-set-montessori': { hook: 'Seven cups, seven balls, one happy sorter', note: 'tongs and spoon included!' },
      'magic-water-drawing-mat-large': { hook: 'Big art, plain water, nothing to scrub', note: 'dries blank for round two!' },
      'montessori-wooden-object-permanence-box': { hook: 'The ball vanishes, then rolls right back', note: 'the classic Montessori box!' },
      'wooden-cutting-fruit-vegetable-set': { hook: 'Twelve wooden foods that really slice apart', note: 'twelve foods, one knife!' },
      'wooden-milk-set-pretend-play-montessori': { hook: 'Four milks for a very serious little shopkeeper', note: 'one solid piece each!' },
      'wooden-calendar-clock-board': { hook: 'Today, the weather and the time, set by them', note: 'a new job every morning!' }
    }
  };
  // this file's folder = the theme's assets folder (live and test copy alike); the cut-outs sit next to it
  var BASE = ((document.currentScript && document.currentScript.src) || '').replace(/[^\/]*$/, '');
  function money(c) { return '$' + (c / 100).toFixed(2); }
  // the legacy band tag age:4-5y means ages 4 AND 5 (the 4-5 collection was split 2026-10-11)
  var AGE = { '0-12m': [0], '1y': [1], '2y': [2], '3y': [3], '4y': [4], '5y': [5], '4-5y': [4, 5] };
  function ageLabel(tags) {
    var min = null, map = { '0-12m': 0, '1y': 1, '2y': 2, '3y': 3, '4y': 4, '4-5y': 4, '5y': 5 };
    (tags || []).forEach(function (t) { var m = /^age:(.+)$/.exec(t); if (m && m[1] in map && (min === null || map[m[1]] < min)) min = map[m[1]]; });
    return min === null ? '' : (min === 0 ? 'From birth' : 'Ages ' + min + '+');
  }
  function ageSet(tags) {
    var on = {};
    (tags || []).forEach(function (t) { var m = /^age:(.+)$/.exec(t); if (m && m[1] in AGE) AGE[m[1]].forEach(function (a) { on[a] = 1; }); });
    return on;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function badge() {
    var pts = [];
    for (var i = 0; i < 32; i++) { var r = i % 2 ? 41 : 48; pts.push((50 + r * Math.cos(Math.PI * i / 16)).toFixed(1) + ',' + (50 + r * Math.sin(Math.PI * i / 16)).toFixed(1)); }
    return '<span class="mw-tc__badge"><svg viewBox="0 0 100 100"><polygon points="' + pts.join(' ') + '" fill="#f6d27a"/>' +
      '<circle cx="50" cy="50" r="35" fill="none" stroke="#ad4a23" stroke-width="1.4" stroke-dasharray="3 3"/>' +
      '<text x="50" y="47" text-anchor="middle" font-family="Fredoka, sans-serif" font-weight="600" font-size="15" fill="#ad4a23">Teacher</text>' +
      '<text x="50" y="64" text-anchor="middle" font-family="Fredoka, sans-serif" font-weight="600" font-size="15" fill="#ad4a23">picked</text></svg></span>';
  }
  function spark(k) { return '<svg class="mw-tc__spark mw-tc__spark--' + k + '" viewBox="0 0 24 24"><path d="M12 0c1 6.5 5.5 11 12 12-6.5 1-11 5.5-12 12-1-6.5-5.5-11-12-12C6.5 11 11 6.5 12 0z"/></svg>'; }
  var ARROW = '<svg class="mw-tc__arrow" viewBox="0 0 60 44"><path d="M4 40 C 14 34, 30 30, 44 10"/><path d="M35 12 L45 8 L46 19"/></svg>';
  function fontOnce(notes) {
    if (document.getElementById('mw-tc-font')) return;
    var chars = {}; notes.join('').split('').forEach(function (c) { chars[c] = 1; });
    var l = document.createElement('link'); l.id = 'mw-tc-font'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap&text=' + encodeURIComponent(Object.keys(chars).join(''));
    document.head.appendChild(l);
  }
  function run() {
    try {
      if (!document.body.classList.contains('template-article')) return;
      var body = document.querySelector('.article__body');
      if (!body || body.querySelector('.mw-toycards')) return;
      var v2 = true; // all posts (owner 2026-10-16)
      var seen = {}, picks = [];
      var links = body.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length && picks.length < MAX; i++) {
        var a = links[i];
        if (a.closest(SKIP)) continue;
        if (a.host && a.host !== location.host) continue; // another shop's /products/ link is not our toy
        var m = /\/products\/([a-z0-9][a-z0-9-]*)/i.exec(a.getAttribute('href') || '');
        if (!m || seen[m[1]]) continue;
        var block = a;
        while (block && block.parentElement !== body) block = block.parentElement;
        if (!block) continue;
        seen[m[1]] = 1;
        picks.push({ handle: m[1], block: block });
      }
      if (!picks.length) return;
      // where each card goes: after the block, or for a heading after the first paragraph / list of its section
      var groups = [];
      picks.forEach(function (p) {
        var after = p.block;
        if (/^H[23]$/.test(after.tagName)) {
          var n = after.nextElementSibling;
          while (n && !/^H[23]$/.test(n.tagName) && !n.matches(SKIP)) {
            if (/^(P|UL|OL)$/.test(n.tagName)) { after = n; break; }
            n = n.nextElementSibling;
          }
        }
        var g = groups.filter(function (x) { return x.after === after; })[0];
        if (!g) { g = { after: after, items: [] }; groups.push(g); }
        g.items.push(p.handle);
      });
      // v2 (owner 2026-10-16): exactly 3 cards (fewer if the post links fewer toys), at the SAME distance from each
      // other: targets at 1/4, 2/4 and 3/4 of the post's height, each snapped to the nearest paragraph edge. The toys
      // are the first 3 the post mentions; the rest keep their text links.
      if (v2) {
        var kids = [].slice.call(body.children).filter(function (k) { return !k.matches(SKIP); });
        var three = picks.slice(0, 3);
        if (kids.length > 7 && three.length) {
          var top0 = kids[0].offsetTop, tail = kids[kids.length - 1];
          var total = (tail.offsetTop + tail.offsetHeight) - top0;
          var used = [];
          groups = [];
          three.forEach(function (p, i) {
            var target = top0 + total * (i + 1) / (three.length + 1);
            // snap to the paragraph edge NEAREST the target, so the distances stay as equal as the text allows
            var at = kids[0], best = Infinity;
            for (var k = 0; k < kids.length; k++) {
              var edge = kids[k].offsetTop + kids[k].offsetHeight, d = Math.abs(edge - target);
              if (d < best) { best = d; at = kids[k]; }
            }
            while (at && (/^H[23]$/.test(at.tagName) || at.matches(SKIP) || used.indexOf(at) > -1)) at = at.previousElementSibling;
            if (!at || (used.length && at.offsetTop <= used[used.length - 1].offsetTop)) return;
            used.push(at);
            groups.push({ after: at, items: [p.handle] });
          });
        } else {
          groups.forEach(function (g) { g.items = g.items.slice(0, 1); });
          groups = groups.slice(0, 3);
        }
        if (!groups.length) return;
      }
      var nth = 0, notes = [], reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      groups.forEach(function (g) {
        var wrap = document.createElement('div');
        wrap.className = 'mw-toycards';
        g.items.forEach(function (h) {
          var d = v2 ? (V2.toys[h] || {}) : null, card = document.createElement('a');
          card.href = '/products/' + h;
          card.setAttribute('data-handle', h);
          if (d) {
            wrap.classList.add('mw-toycards--v2');
            card.className = 'mw-tc mw-tc--' + (nth++ % 2 ? 'olive' : 'terra') + ' is-loading';
            card.setAttribute('data-design', 'v2');
            var cells = '';
            for (var k = 0; k < 6; k++) cells += '<span class="mw-tc__age" data-age="' + k + '">' + (k === 5 ? '5+' : k) + '</span>';
            card.innerHTML = '<span class="mw-tc__band"><span class="mw-tc__clip" aria-hidden="true"><span class="mw-tc__spot"></span></span>' +
              '<span class="mw-tc__txt"><span class="mw-tc__hook">' + esc(d.hook || '') + '</span><span class="mw-tc__name">&nbsp;</span>' +
              '<span class="mw-tc__ages" aria-hidden="true">' + cells + '</span><span class="mw-tc__btn">See the toy <span aria-hidden="true">→</span></span></span>' +
              '<span class="mw-tc__stage" aria-hidden="true">' + spark('a') + spark('b') +
              '<img class="mw-tc__toy' + (d.cut ? '' : ' is-photo') + '" alt="" width="' + (d.cut ? d.w : 400) + '" height="' + (d.cut ? d.h : 400) + '" decoding="async">' +
              badge() + (d.note ? '<span class="mw-tc__note">' + ARROW + '<span class="mw-tc__note-txt">' + esc(d.note) + '</span></span>' : '') + '</span>' +
              '<span class="mw-tc__foot">Free US shipping over $70 · 60-day returns</span></span>';
            if (d.note) notes.push(d.note);
          } else {
            card.className = 'mw-toycard is-loading';
            card.setAttribute('data-design', 'v1');
            card.setAttribute('aria-hidden', 'true');
            card.tabIndex = -1;
            card.innerHTML = '<span class="mw-toycard__img"></span><span class="mw-toycard__txt"><span class="mw-toycard__name"></span><span class="mw-toycard__meta"></span><span class="mw-toycard__cta">See the toy</span></span>';
          }
          wrap.appendChild(card);
        });
        wrap.setAttribute('data-n', String(wrap.querySelectorAll('.mw-toycard').length));
        g.after.insertAdjacentElement('afterend', wrap);
      });
      if (notes.length) fontOnce(notes);
      function drop(card) {
        var wrap = card.parentElement;
        card.remove();
        if (wrap && !wrap.firstElementChild) wrap.remove();
        else if (wrap) wrap.setAttribute('data-n', String(wrap.querySelectorAll('.mw-toycard').length));
      }
      function fill(card) {
        var h = card.getAttribute('data-handle'), design = card.getAttribute('data-design');
        fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p || !p.available) throw 0;
          var age = ageLabel(p.tags);
          if (design === 'v2') {
            var d = V2.toys[h] || {}, on = ageSet(p.tags), ages = [];
            if (d.hook) { card.querySelector('.mw-tc__name').textContent = p.title; }
            else { card.querySelector('.mw-tc__hook').textContent = p.title; card.querySelector('.mw-tc__name').textContent = ''; }
            [].forEach.call(card.querySelectorAll('.mw-tc__age'), function (c) { if (on[c.getAttribute('data-age')]) { c.classList.add('is-on'); ages.push(c.textContent); } });
            var img = card.querySelector('.mw-tc__toy');
            img.src = d.cut ? BASE + d.cut : (p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '');
            img.alt = p.title; // 2026-10-23: the toy photo carries the product name (Google image search); the card itself stays aria-labelled
            card.setAttribute('aria-label', (d.hook ? d.hook + '. ' : '') + p.title + (ages.length ? ', best for ages ' + ages.join(' and ') : '') + '. Teacher-picked. See the toy');
          } else {
            var src = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
            var price = p.price_min !== p.price_max ? 'From ' + money(p.price_min) : money(p.price_min != null ? p.price_min : p.price);
            card.querySelector('.mw-toycard__img').innerHTML = src ? '<img src="' + esc(src) + '" alt="" width="88" height="88" loading="lazy" decoding="async">' : '';
            card.querySelector('.mw-toycard__name').textContent = p.title;
            card.querySelector('.mw-toycard__meta').textContent = (age ? age + ' · ' : '') + price;
            card.setAttribute('aria-label', p.title + ', ' + (age ? age + ', ' : '') + price + '. See the toy');
            card.removeAttribute('aria-hidden');
            card.removeAttribute('tabindex');
          }
          card.classList.remove('is-loading');
          card.addEventListener('click', function () {
            try { if (window.gtag) window.gtag('event', 'blog_toy_card_click', { item_name: p.title, item_id: String(p.id), post: location.pathname, design: design }); } catch (e) {}
          });
        }).catch(function () { drop(card); });
      }
      var cards = body.querySelectorAll('.mw-toycard.is-loading, .mw-tc.is-loading');
      if (!('IntersectionObserver' in window)) { for (var q = 0; q < cards.length; q++) fill(cards[q]); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fill(e.target); } });
      }, { rootMargin: '800px 0px' });
      for (var j = 0; j < cards.length; j++) io.observe(cards[j]);
      // v2 entrance: only for cards that start below the screen; they play once when a third of the card is in view
      if (reduce) return;
      var show = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          show.unobserve(e.target);
          requestAnimationFrame(function () { e.target.classList.add('is-in'); e.target.classList.remove('is-pre'); });
        });
      }, { threshold: 0.35 });
      [].forEach.call(body.querySelectorAll('.mw-tc'), function (c) {
        if (c.getBoundingClientRect().top > window.innerHeight) { c.classList.add('is-pre'); show.observe(c); }
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ---- blog + article: guide sign-up cards ---- */
/* MirthWell blog: a guide sign-up card in the trailing grid slot. Posts to Shopify's own
   customer capture (/contact), tagged so blog sign-ups are separable from the homepage form.
   Defensive: if the grid is missing, do nothing. */
(function () {
  function build() {
    try {
      var isBlog = document.body.classList.contains('template-blog');
      var isArticle = document.body.classList.contains('template-article');
      if (!isBlog && !isArticle) return;
      if (document.querySelector('.mw-guide-card')) return;
      var grid = isBlog ? document.querySelector('.grid--uniform') : null;
      var articleBody = isArticle ? document.querySelector('.article__body') : null;
      if (!grid && !articleBody) return;

      var cell = document.createElement('div');
      cell.className = 'grid__item medium-up--one-third';
      cell.setAttribute('data-mw-guide', '1');

      var posted = /[?&]customer_posted=true/.test(window.location.search);
      var inner = '<div class="mw-guide-card">';
      if (posted) {
        inner += '<div class="mw-guide-card__mark" aria-hidden="true"></div><div class="mw-guide-card__body"><p class="mw-guide-card__eyebrow">Thank you</p>' +
                 '<p class="mw-guide-card__done">Your guide is on its way. If it has not arrived in ' +
                 'a few minutes, check your spam folder.</p></div>';
      } else {
        inner += '<div class="mw-guide-card__mark" aria-hidden="true"></div><div class="mw-guide-card__body">' +
                 '<p class="mw-guide-card__eyebrow">Free guide</p>' +
                 '<h2 class="mw-guide-card__title">The Ultimate Guide to Montessori at Home</h2>' +
                 '<p class="mw-guide-card__sub">Setting up a shelf, choosing toys, and knowing when ' +
                 'your child is ready for the next thing. Sent straight to your inbox.</p>' +
                 '<form method="post" action="/contact" accept-charset="UTF-8" class="mw-guide-card__row">' +
                 '<input type="hidden" name="form_type" value="customer">' +
                 '<input type="hidden" name="utf8" value="✓">' +
                 '<input type="hidden" name="contact[tags]" value="prospect,newsletter,guide,blog">' +
                 '<label class="hidden-label" for="mw-guide-email">Your email</label>' +
                 '<input id="mw-guide-email" type="email" name="contact[email]" required ' +
                 'autocomplete="email" placeholder="Your email">' +
                 '<button type="submit" name="commit">Send me the guide</button>' +
                 '</form>' +
                 '<p class="mw-guide-card__note">One email with the guide. Unsubscribe any time.</p></div>';
      }
      inner += '</div>';
      cell.innerHTML = inner;
      if (grid) { grid.appendChild(cell); return; }

      /* --- in-post cards -------------------------------------------------------------
         Built by a factory rather than cloned, so the mid and end cards can say different
         things. A reader who declined the identical box four screens earlier has already
         answered that question; the end card has to earn a second look on its own. */
      var handle = (window.location.pathname.split('/').filter(Boolean).pop() || '');
      var OFFER = {
        'how-many-toys-should-a-toddler-have':
          'You have the rotation. The guide is the shelf it sits on \u2014 what to put out at each age, and what to stop buying.',
        'are-montessori-toys-better':
          'How to tell a good wooden toy from an expensive one, without trusting the word on the box.',
        'how-long-should-a-toddler-play-independently':
          'Setting up a room a child will actually settle in, age by age, without buying more.',
        'montessori-at-home-where-to-start':
          'What comes after the low shelf and the stool \u2014 the next two months, room by room.',
        'when-do-toddlers-start-doing-puzzles':
          'What to put out at each age, and how to tell when something is one notch too hard.',
        'montessori-vs-waldorf':
          'What to actually put on the shelf, whichever side of this you lean towards.'
      };
      var DEFAULT_SUB = 'Shelf setup, what to put out at each age, and knowing when your child is ' +
                        'ready for the next thing. One email, no course.';

      function card(o) {
        var d = document.createElement('div');
        d.className = 'mw-guide-card';
        d.id = o.id;
        d.innerHTML =
          '<div class="mw-guide-card__mark" aria-hidden="true"></div><div class="mw-guide-card__body">' +
          '<p class="mw-guide-card__eyebrow">' + o.eyebrow + '</p>' +
          '<h2 class="mw-guide-card__title">' + o.title + '</h2>' +
          '<p class="mw-guide-card__sub">' + o.sub + '</p>' +
          '<form method="post" action="/contact#' + o.id + '" accept-charset="UTF-8" class="mw-guide-card__row">' +
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="\u2713">' +
          '<input type="hidden" name="contact[tags]" value="prospect,newsletter,guide,blog,' + o.slot + '">' +
          '<label class="hidden-label" for="' + o.id + '-email">Your email</label>' +
          '<input id="' + o.id + '-email" type="email" name="contact[email]" required ' +
          'autocomplete="email" placeholder="Your email">' +
          '<button type="submit" name="commit">Send me the guide</button>' +
          '</form>' +
          '<p class="mw-guide-card__note">One email with the guide. Unsubscribe any time.</p></div>';
        return d;
      }
      function thanks(el) {
        el.innerHTML =
          '<div class="mw-guide-card__mark" aria-hidden="true"></div><div class="mw-guide-card__body">' +
          '<p class="mw-guide-card__eyebrow">Thank you</p>' +
          '<p class="mw-guide-card__done">Your guide is on its way. If it has not arrived in ' +
          'a few minutes, check your spam folder.</p></div>';
      }

      var atEnd = card({
        id: 'mw-guide-end', slot: 'end',
        eyebrow: 'You read the whole thing',
        title: 'The Ultimate Guide to Montessori at Home',
        sub: 'This post covered one corner of it. The guide covers the rest \u2014 room by room, ' +
             'age by age, and what to stop buying.'
      });
      articleBody.insertAdjacentElement('afterend', atEnd);

      var heads = articleBody.querySelectorAll('h2');
      /* Place the first card before the FIRST heading: by then the standfirst has already given
         the reader the answer they came for, which is the moment of most goodwill and least
         remaining obligation. Unless the paragraph just above it is the sell-side disclosure,
         in which case fall through to the next heading rather than bolt a signup form onto an
         honesty beat. */
      function disclosure(h) {
        var prev = h.previousElementSibling;
        return !!prev && /we sell/i.test(prev.textContent || '');
      }
      var first = 0;
      while (first < heads.length && disclosure(heads[first])) first++;
      if (first >= heads.length) first = 0;

      var isPhone = window.matchMedia('(max-width: 749px)').matches;
      var slots = [];
      if (heads.length >= 3) {
        slots.push(first);
        /* A post runs ~11,000px on a 390px screen against ~4,000px on desktop, so a phone gets a
           second in-body card further down; desktop does not need one. */
        if (isPhone) {
          var second = Math.min(heads.length - 1, first + 3);
          if (second > first) slots.push(second);
        }
      }
      slots.forEach(function (idx, i) {
        heads[idx].insertAdjacentElement('beforebegin', card({
          id: 'mw-guide-mid' + (i + 1), slot: 'mid' + (i + 1),
          eyebrow: 'Free guide',
          title: 'The rest of this, in one guide',
          sub: OFFER[handle] || DEFAULT_SUB
        }));
      });

      /* Shopify returns to the article with ?customer_posted=true; the anchor tells us which
         card was used, so only that one flips to the thank-you and the browser lands the reader
         back where they were instead of at the hero. */
      if (posted) {
        var target = (window.location.hash && document.querySelector('.mw-guide-card' + window.location.hash)) ||
                     document.getElementById('mw-guide-end');
        if (target) thanks(target);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();

/* ---- pages: form thank-you ---- */
/* Shopify redirects back with ?contact_posted=true after a successful post. Show the matching
   card's thank-you and hide its form, rather than leaving a filled-in form looking unsent. */
(function () {
  function done() {
    try {
      if (!/[?&]contact_posted=true/.test(window.location.search)) return;
      var wrap = document.querySelector('.mw-form' + (window.location.hash || '')) ||
                 document.querySelector('.mw-form');
      if (!wrap) return;
      var ok = wrap.querySelector('.mw-form__done');
      var form = wrap.querySelector('.mw-form__form');
      var intro = wrap.querySelector('.mw-form__intro');
      if (ok) ok.hidden = false;
      if (form) form.hidden = true;
      if (intro) intro.hidden = true;
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', done);
  else done();
})();

/* ---- blog: guide card placement ---- */
/* Mobile: park the guide card after the pagination, in the footer zone. Desktop: leave it as
   the trailing grid cell. Runs after the earlier placement script and supersedes it. */
(function () {
  function park() {
    try {
      if (!document.body.classList.contains('template-blog')) return;
      var card = document.querySelector('[data-mw-guide]');
      var grid = document.querySelector('.grid--uniform');
      if (!card || !grid) return;
      var pager = document.querySelector('.pagination, .pagination-wrapper, [class*="pagination"]');
      if (window.matchMedia('(max-width: 749px)').matches) {
        var anchor = pager || grid;
        if (anchor.nextElementSibling !== card) anchor.insertAdjacentElement('afterend', card);
      } else if (grid.lastElementChild !== card) {
        grid.appendChild(card);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', park);
  else park();
  window.addEventListener('resize', park);
  setTimeout(park, 400);
})();

/* ---- blog: topic row ---- */
/* The one DOM job left on the blog: the section row scrolls sideways on a phone, so fade the
   right edge until it is scrolled to the end, and open it scrolled to the archive you are on.
   Everything else about a tag — its markup, its colour, its lack of a hover — is in Liquid and
   in the CSS above. */
(function () {
  // This snippet is rendered inside <head>, so the nav does not exist yet on first execution.
  // Without this wait the row is null and nothing below ever attaches.
  function init() {
  var row = document.querySelector('body.template-blog .mw-blog-topics');
  if (!row) return;
  function edge() {
    row.classList.toggle('mw-scroll-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
  }
  row.addEventListener('scroll', edge, { passive: true });
  window.addEventListener('resize', edge);
  var current = row.querySelector('[aria-current="page"]');
  if (current && window.matchMedia('(max-width: 749px)').matches) {
    var left = current.offsetLeft - 16;
    if (left > 0) row.scrollLeft = left;
  }
  edge();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- free-shipping progress bar (every page; config in snippets/mw-shipping-bar.liquid) ---- */
(function () {
  var CFG = window.MW_SHIP || {};
  var T = CFG.threshold || 7000;
  var current = typeof CFG.initial === 'number' ? CFG.initial : 0;
  var count = typeof CFG.initialCount === 'number' ? CFG.initialCount : 0;
  var mounted = [];
  // 2026-10-20: package rule (snippets/mw-ship-rule.liquid). When packages ship free, a cart with that many toys
  // has free shipping at any total (an automatic free-shipping discount), and one toy short gets its own message.
  var PK = CFG.pack || {};
  var PK_FREE = PK.min > 0 && !!PK.ship;

  var TRUCK = '<svg class="mw-shipbar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>';
  var CHECK = '<svg class="mw-shipbar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m8 12.5 2.5 2.5L16 9.5"/></svg>';

  // trim: drop the ".00" on whole-dollar amounts — "over $70" reads better than "over $70.00".
  // Partial amounts ("Add $21.01 more") always keep their cents.
  function money(cents, trim) {
    var out;
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        out = theme.Currency.formatMoney(cents, (theme.settings && theme.settings.moneyFormat) || CFG.format);
      }
    } catch (e) {}
    if (!out) {
      out = '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    if (trim && cents % 100 === 0) out = out.replace(/([.,])00\b/, '');
    return out;
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'mw-shipbar';
    el.innerHTML =
      '<p class="mw-shipbar__msg" aria-live="polite"></p>' +
      '<div class="mw-shipbar__track" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
        '<span class="mw-shipbar__fill"></span>' +
      '</div>';
    return el;
  }

  function paint(el, cents, n, animate) {
    var pkOn = PK.min > 0 && n >= PK.min;      /* the 10% applies */
    var pkDone = PK_FREE && pkOn;              /* the set alone ships free (package_ships_free; off since 2026-10-23) */
    // 2026-10-22 (owner): product page with an EMPTY cart: a toy priced at or above the threshold ships free on its own, so the
    // box says so with a full bar instead of the generic "over $70" line over an empty bar. Carts with items and the cart bars
    // keep the cart-based message. CFG.productPrice = the current variant's price in cents (snippets/mw-shipping-bar.liquid).
    var pdpFree = cents <= 0 && el.hasAttribute('data-pdp') && T > 0 && (CFG.productPrice || 0) >= T;
    var done = cents >= T || pkDone || pdpFree;
    var pct  = done ? 100 : (T > 0 ? Math.max(0, Math.min(100, (cents / T) * 100)) : 100);
    var left = T - cents;
    var was  = el.classList.contains('is-done');

    el.classList.toggle('is-done', done);
    if (done && !was && animate) {
      el.classList.add('just-unlocked');
      setTimeout(function () { el.classList.remove('just-unlocked'); }, 600);
    }

    var msg = el.querySelector('.mw-shipbar__msg');
    if (pdpFree) {
      msg.innerHTML = CHECK + '<span>This toy ships <b>free</b> in the US.</span>';
    } else if (done) {
      msg.innerHTML = CHECK + (pkOn
        ? '<span>' + n + ' toys: <b>' + PK.pct + '% off</b> and <b>free shipping</b>.</span>'
        : '<span>Your order ships <b>free</b>.</span>');
    } else if (cents <= 0) {
      msg.innerHTML = TRUCK + '<span>Free shipping on US orders over <b>' + money(T, true) + '</b>.</span>';
    } else if (pkOn) {
      msg.innerHTML = TRUCK + '<span>' + n + ' toys: <b>' + PK.pct + '% off</b>. Add <b>' + money(left) + '</b> more for <b>free shipping</b>.</span>';
    } else if (PK.min > 0 && n === PK.min - 1) {
      msg.innerHTML = TRUCK + '<span>Add <b>1 more toy</b>: ' + PK.pct + '% off all ' + PK.min + (PK_FREE ? ' and free shipping' : '') + '.</span>';
    } else {
      msg.innerHTML = TRUCK + '<span>Add <b>' + money(left) + '</b> more for <b>free shipping</b>.</span>';
    }

    var track = el.querySelector('.mw-shipbar__track');
    track.setAttribute('aria-valuenow', Math.round(pct));
    el.querySelector('.mw-shipbar__fill').style.width = pct + '%';
  }

  function paintAll(cents, n, animate) {
    current = cents;
    if (typeof n === 'number') count = n;
    for (var i = 0; i < mounted.length; i++) {
      if (mounted[i].isConnected) paint(mounted[i], cents, count, animate);
    }
  }

  function attach(el) {
    mounted.push(el);
    paint(el, current, count, false);
  }

  /* 2026-10-20 (owner): "Bundle & save" package box (snippets/mw-pkg.liquid; v2 the same evening: simpler, no tick
     boxes, 10%; v3 2026-10-21: tag beside the name, struck price + new price on one row). Keeps the struck
     "separately" price, the bundle price, the shipping saving and the saving on the button true when the shopper changes a
     companion's option or this toy's option, and adds the 3 toys in one request. A toy already in the cart is not
     added twice. Same maths as the Liquid: Shopify floors the % discount to the cent; "Separately" adds the standard
     fee when the 3 toys alone are under the free-shipping line. */
  function initPackage() {
    document.querySelectorAll('.mw-pkg').forEach(function (box) {
      if (box.dataset.mwInit) return;
      box.dataset.mwInit = '1';
      var d = box.dataset;
      var pct = parseInt(d.pct, 10) || 0, freeShip = d.ship === '1';
      var line = parseInt(d.t, 10) || 0, fee = parseInt(d.fee, 10) || 0;
      var mainIds = (d.mainVariants || '').split(',');
      // 2026-10-23: the set card can swap its two companions (the arrow next to its "?"), so the rows are read when used
      var rowsNow = function () { return Array.prototype.slice.call(box.querySelectorAll('.mw-pkg__item')); };
      var main = box.querySelector('.mw-pkg__item.is-main');
      var btn = box.querySelector('.mw-pkg__btn');
      var wasEl = box.querySelector('.mw-pkg__was-num');
      var nowEl = box.querySelector('.mw-pkg__now');
      var shipSaveEl = box.querySelector('.mw-pkg__shipsave');
      var mainOk = true;
      function update() {
        var sum = 0;
        var rows = rowsNow();
        rows.forEach(function (r) { sum += parseInt(r.dataset.price, 10) || 0; });
        var now = sum - Math.floor(sum * pct / 100);
        var sepShip = sum < line ? fee : 0;
        var bunShip = (!freeShip && now < line) ? fee : 0;
        var save = sum + sepShip - now - bunShip;
        wasEl.textContent = money(sum);
        nowEl.textContent = money(now);
        if (shipSaveEl) shipSaveEl.textContent = sepShip ? ' (saves ' + money(sepShip) + ')' : '';
        if (!btn.classList.contains('is-loading') && !btn.classList.contains('is-added')) {
          btn.textContent = mainOk ? 'Add all ' + rows.length + ' · Save ' + money(save) : 'This option is sold out';
        }
        btn.disabled = !mainOk;
      }
      box.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.classList.contains('mw-pkg__select')) return;
        // 2026-10-22 (new buy box): the picker may sit under the pictures, outside its row; data-mw-row ties them together
        var o = t.options[t.selectedIndex], row = t.closest('.mw-pkg__item') || box.querySelector('.mw-pkg__item[data-mw-row="' + t.getAttribute('data-mw-row') + '"]');
        if (!row) return;
        row.dataset.id = o.value;
        row.dataset.price = o.getAttribute('data-price');
        row.querySelector('.mw-pkg__price').textContent = money(parseInt(row.dataset.price, 10));
        update();
      });
      box.addEventListener('mw:pkg-rows', function () { update(); });
      // This toy's own option picker (Impulse fires variant:change on document with the variant object).
      document.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v || mainIds.indexOf(String(v.id)) < 0) return;
        main.dataset.id = v.id;
        main.dataset.price = v.price;
        main.querySelector('.mw-pkg__price').textContent = money(v.price);
        var img = v.featured_image && v.featured_image.src;
        var pic = main.querySelector('.mw-pkg__img img');
        if (img && pic) { pic.removeAttribute('srcset'); pic.src = img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=320'; }  /* 320: the new card shows it at up to 104 CSS px on 2-3x screens */
        mainOk = !!v.available;
        update();
      });
      var err = null;
      function showErr(msg) {
        if (!err) { err = document.createElement('p'); err.className = 'mw-pkg__err'; err.setAttribute('role', 'alert'); btn.parentNode.insertBefore(err, btn.nextSibling); }
        err.textContent = msg;
      }
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        if (err) err.textContent = '';
        btn.classList.add('is-loading');
        btn.textContent = 'Adding…';
        var rows = rowsNow();
        var ids = rows.map(function (r) { return parseInt(r.dataset.id, 10); });
        function finish() { btn.classList.remove('is-loading'); update(); }
        // 2026-10-23 (owner, cart list A3 + D18): sage-green "Added ✓" for 2 s; a second tap says so, then opens the drawer.
        var status = box.querySelector('.mw-pkg__status');
        if (!status) { status = document.createElement('p'); status.className = 'mw-pkg__status visually-hidden'; status.setAttribute('role', 'status'); btn.parentNode.insertBefore(status, btn.nextSibling); }
        function flash(label, then) {
          btn.classList.add('is-added'); btn.textContent = label; status.textContent = label;
          setTimeout(function () { btn.classList.remove('is-added'); update(); if (then) then(); }, 2000);
        }
        fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (cart) {
            var have = {};
            ((cart && cart.items) || []).forEach(function (i) { have[i.variant_id] = true; });
            var items = ids.filter(function (id) { return !have[id]; }).map(function (id) { return { id: id, quantity: 1 }; });
            if (!items.length) { finish(); flash('All ' + rows.length + ' are in your cart', function () { document.dispatchEvent(new CustomEvent('cart:open')); }); return; }
            var route = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
            return fetch(route, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: items })
            }).then(function (r) {
              return r.json().then(function (j) { return { ok: r.ok, j: j }; });
            }).then(function (res) {
              finish();
              if (!res.ok || res.j.status) {
                showErr((res.j && res.j.description) || 'Sorry, one of these toys just sold out. Please reload the page.');
                return;
              }
              flash('Added ✓');
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.j.items && res.j.items[0] } }));
            });
          })
          .catch(function () { finish(); showErr('Something went wrong. Please try again.'); });
      });
      update();
    });
  }

  /* ---- mount points -------------------------------------------------- */

  // Product page: directly under the Add to Cart button. mw-custom.liquid inserts
  // .mw-payrow after the same block, so ours lands between the button and the icons.
  function mountProduct() {
    if (!document.body.classList.contains('template-product')) return true;
    var meta = document.querySelector('.product-single__meta');
    if (!meta) return false;
    if (meta.querySelector('.mw-shipbar')) return true;
    var atc = meta.querySelector('.add-to-cart');
    if (!atc) return false;
    var host = atc.closest('.product-block') || atc.parentNode;
    var el = build();
    el.setAttribute('data-pdp', '1');
    // 2026-10-22 (owner): stock + delivery line inside the box. Text comes from snippets/mw-shipping-bar.liquid (the days are
    // the shipping policy's) and is empty when the current variant is not available, so the line simply does not show.
    if (CFG.eta) { var eta = document.createElement('p'); eta.className = 'mw-shipbar__eta'; eta.textContent = CFG.eta; el.appendChild(eta); }
    host.parentNode.insertBefore(el, host.nextSibling);
    attach(el);
    mountPackage(el);
    return true;
  }

  // 2026-10-20: the "Make it a package" box waits inert in <template id="mw-pkg-tpl"> (snippets/mw-shipping-bar.liquid
  // renders it on product pages) and goes in right under this bar. Kept out of the buy-box files on purpose: other
  // chats guard those files by checksum, and the box is ours alone. Phones: mw-custom's flex order keeps it under the
  // bar too (the bar is order 4, everything else order 5).
  function mountPackage(bar) {
    var tpl = document.getElementById('mw-pkg-tpl');
    if (!tpl || !tpl.content || document.querySelector('.product-single__meta .mw-pkg')) return;
    var frag = tpl.content.cloneNode(true);
    if (!frag.querySelector('.mw-pkg')) return;
    bar.parentNode.insertBefore(frag, bar.nextSibling);
    try { initPackage(); } catch (e) {}
  }


  // Cart drawer AND cart page share .cart__checkout-wrapper — one selector covers both.
  // Impulse only re-renders [data-products] / [data-discounts] / [data-subtotal] on
  // cart:updated, so a bar placed here survives every rebuild.
  function mountCarts() {
    // 2026-10-23 (owner): the bar sits in the drawer's fixed bottom above the subtotal and at the top of the cart page's summary
    // card, wherever the templates offer [data-mw-shipbar-top] (snippets/cart-drawer.liquid, sections/main-cart.liquid); the old
    // placement above the checkout button otherwise. assets/mw-cart.css gives it the buy-box look there.
    var tops = document.querySelectorAll('[data-mw-shipbar-top]');
    for (var t = 0; t < tops.length; t++) {
      if (tops[t].querySelector('.mw-shipbar')) continue;
      var top = build();
      tops[t].appendChild(top);
      attach(top);
    }
    var wraps = document.querySelectorAll('.cart__checkout-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var form = w.closest('form');
      if (form && form.querySelector('[data-mw-shipbar-top]')) continue;
      if (w.previousElementSibling && w.previousElementSibling.classList.contains('mw-shipbar')) continue;
      var el = build();
      w.parentNode.insertBefore(el, w);
      attach(el);
    }
    return (tops.length + wraps.length) > 0;
  }

  function mountAll() {
    var a = mountProduct();
    var b = mountCarts();
    return a && b;
  }

  /* ---- cart state ----------------------------------------------------- */

  /* 2026-10-27 (owner): toy sets (product type "Toy Set") are not part of the "10% off 3+ toys" offer, so they don't count here */
  function toyCount(c) { var n = 0; (c.items || []).forEach(function (i) { if (String(i.product_type || '') !== 'Toy Set') n += i.quantity || 0; }); return n; }

  function refresh(animate) {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || typeof c.total_price !== 'number') return;
        paintAll(c.total_price, toyCount(c), animate);
        document.dispatchEvent(new CustomEvent('mw:cart', { detail: { cart: c } })); /* assets/mw-cart.js reads the same cart from here */
      })
      .catch(function () {});
  }

  /* the cart drawer's single pick (free shipping / complete the set) is computed and rendered by assets/mw-cart.js since 2026-10-23 */

  function boot() {
    mountAll();
    // The Liquid-rendered `initial` can be stale behind Shopify's full-page cache, so always
    // reconcile against the live cart once on load.
    refresh(false);

    // Impulse dispatches this on every add / qty change / remove, with the parsed cart.
    document.addEventListener('cart:updated', function (e) {
      var c = e && e.detail && e.detail.cart;
      if (c && typeof c.total_price === 'number') paintAll(c.total_price, toyCount(c), true);
      else refresh(true);
      mountCarts();
    });

    // Belt-and-braces: catch any cart write that doesn't go through Impulse's CartForm
    // (quick-add on cards, Shopify's own AJAX, apps) by watching the network.
    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function (input) {
        var url = (typeof input === 'string' ? input : (input && input.url)) || '';
        var p = _fetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(function () { refresh(true); mountCarts(); }, 60); }).catch(function () {});
        }
        return p;
      };
    }
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|update|clear)/.test(url || '')) {
        this.addEventListener('load', function () { setTimeout(function () { refresh(true); mountCarts(); }, 60); });
      }
      return _open.apply(this, arguments);
    };

    // The drawer is built lazily and mw-custom rearranges the buy box after DOMContentLoaded —
    // retry mounting for a few seconds, then stop.
    var tries = 0;
    var iv = setInterval(function () {
      if (mountAll() || ++tries > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
